export const CURSOR_WHITELIST = [
  1985869848,
  2818514498,
  2818551707,
  2818895905,
  2818915634,
  1538297577,
  1538520189,
  1538833152,
  1538895866,
  1538992544,
  1539874627,
  1540822137,
  1543038223,
  1543372001,
  1559115778,
  1559314091,
  1559536005,
  1559652082,
  1559725062,
  1559829441,
  1560188378,
  1560288762,
  1560348975,
  1973101339,
  469135305,
  469456369,
  469527076,
  469786086,
  469891101,
  470042200,
  470110142,
  470368049,
  470568483,
  470705799,
  470893795,
  470974887,
  471146342,
  471220902,
  471450673,
  471570340,
  471704564,
  877189253,
  877334156,
  877546198,
  877762638,
  877957755,
  878299378,
  878596102,
  879456162,
  473372793,
  473442805,
  473619734,
  473683409,
  473745813,
  473832416,
  473903651,
  473965684,
  474040215,
  474261300,
  474341389,
  474420398,
  474657751,
  854495034,
  474734399,
  474808996,
  474905398,
  476025574,
  480933353,
  481028879,
  481253237,
  481384942,
  481504945,
  481678521,
  481759983,
  481839251,
  481991487,
  482087744,
  482392291,
  482788525,
  482857199,
  483071039,
  483165630,
  483260769,
  483356137,
  483448276,
  483524415,
  483616857,
  483723799,
  483805553,
  483889828,
  483975159,
  484572715,
  485301758,
  485687526,
  485799430,
  485903302,
  485994281,
  486082920,
  487058703,
  487183295,
  487261574,
  487357357,
  487451610,
  487547224,
  487630620,
  487715396,
  487839863,
  488530445,
  489054627,
  489220184,
  489336260,
  489513178,
  489616428,
  489702498,
  489829657,
  489919518,
  490013321,
  490147995,
  490254630,
  490362585,
  490445442,
  490703488,
  491602842,
  491983659,
  492070422,
  492217482,
  492319948,
  492430861,
  492537315,
  492642811,
  492726815,
  492811811,
  492890161,
  492983919,
  493071219,
  493161937,
  493236116,
  493320629,
  493483145,
  493786076,
  493865804,
  493941033,
  494039019,
  494256771,
  551688715,
  551785554,
  551864563,
  551952979,
  552044439,
  552114954,
  552188732,
  552261587,
  552346986,
  552417017,
  552502023,
  552896459,
  553016700,
  553117016,
  553212124,
  553407110,
  553505007,
  553598506,
  553806417,
  553894022,
  553989928,
  554065044,
  554163764,
  554344483,
  1112369282,
  556800958,
  557042106,
  557490851,
  557809864,
  558532396,
  558703203,
  933363413,
  938365157,
  938553731,
  938665600,
  559095209,
  559529740,
  559676264,
  940058316,
  940135067,
  940227753,
  940304158,
  940393060,
  940502425,
  940575613,
  568695184,
  568787070,
  568869995,
  568969864,
  569051099,
  569140744,
  569232057,
  569308885,
  569387304,
  576667276,
  576768998,
  576848313,
  857729675,
  861233562,
  876295810,
  876542274
];

export const MAX_AUDIO_SIZE = 15000000;

export const ACCOUNT_TYPES = {
  FREE: 'FREE',
  CREATOR: 'TIER100'
};

export const APP_DATA_KEYS = {
  FREE_DOWNLOAD_COUNT: 'freedlcount',
  USER_SETTINGS: 'usersettings'
};

export const FILE_FORMATS = [
  {
    key: '720MP4_H264',
    title: 'MP4',
    name: '720MP4_H264',
    id: '720MP4_H264',
    infoI18nKey: 'download-mp4-description',
    label: 'MP4'
  },
  {
    key: '420GIF_12FPS',
    title: 'GIF',
    name: '420GIF_12FPS',
    id: '420GIF_12FPS',
    infoI18nKey: 'download-gif-description',
    label: 'GIF'
  }
];

export const maxLibraryImageUploadRetries = 5;

export const maxUserImageUploadRetries = 3;

export const maxImageUploadOnScribeLoadRetries = 1;
